var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"t_tabbar"},[_c('van-tabbar',{attrs:{"route":""}},_vm._l((_vm.TabbarList),function(item,key){return _c('van-tabbar-item',{key:key,class:{'noPath': !item.path},attrs:{"to":item.path,"icon":item.icon}},[_vm._v(" "+_vm._s(item.title)+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }